export default __webpack_public_path__ + "static/media/Mark-3-HUD-Header.ae38d141.jpg";